/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeTableCategoryCell } from "../../d-table-category-cell";
import { DThemeWhiteTableHeaderCell } from "./d-theme-white-table-header-cell";

export class DThemeWhiteTableCategoryCell
	extends DThemeWhiteTableHeaderCell
	implements DThemeTableCategoryCell {}
